import React from 'react';
import { DataTable } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { users } from '../data/mockData';

export default function Users() {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'role', label: 'Role' },
    { 
      key: 'status', 
      label: 'Status',
      render: (row) => <StatusBadge status={row.status} />
    }
  ];

  return (
    <div className="page-container" data-testid="users-page">
      <div className="page-header">
        <h1 className="page-title">Users</h1>
        <p className="page-subtitle">Manage user accounts and permissions</p>
      </div>

      <DataTable 
        columns={columns} 
        data={users}
        searchable={true}
        emptyMessage="No users found"
      />
    </div>
  );
}
